import { useEffect,useState } from "react";
import { Link } from 'react-router-dom';
function HomeStudent({userFullName}) {

  return (
    <main>
      <article className='newPost'>
      <div className="fullWidth">
      <p className="text text-info baseddDiv">{userFullName}</p>

          <div className="fullWidth featureContainer ">
         
       <Link
        to="/viewresult/2024-DECEMBER"
        className="w-[120px] h-[120px] text-xs m-2 bg-blue-500 text-white rounded-xl shadow-md flex items-center justify-center text-center hover:bg-blue-600 transition"
      >
        Result 2024-DECEMBER Exam
      </Link>



       <Link
        to="/viewresult/2025-MAY"
        className="w-[120px] h-[120px] text-xs m-2 bg-blue-500 text-white rounded-xl shadow-md flex items-center justify-center text-center hover:bg-blue-600 transition"
      >
        Result 2025-May Exam
      </Link>


       <Link
        to="/viewresult/2025-DECEMBER"
        className="w-[120px] h-[120px] text-xs m-2 bg-blue-500 text-white rounded-xl shadow-md flex items-center justify-center text-center hover:bg-blue-600 transition"
      >
        Result 2025-December Exam
      </Link>

      <Link
        to="/viewresult/2026-MAY"
        className="w-[120px] h-[120px] text-xs m-2 bg-green-500 text-white rounded-xl shadow-md flex items-center justify-center text-center hover:bg-green-600 transition"
      >
        Result 2026-May Exam
      </Link>

     


          </div>
          {true && (<div className="flex justify-center">
            
            <Link
        to="/doformfillup2025december"
        className="w-[120px] h-[120px] text-xs m-2 bg-green-600 text-white rounded-xl shadow-md flex items-center justify-center text-center hover:bg-green-700 transition"
      >
        Form Fillup 2025-DEC Exam (ODD SEM)
      </Link>
      <Link
        to="/doformfillup2026may"
        className="w-[120px] h-[120px] text-xs m-2 bg-green-600 text-white rounded-xl shadow-md flex items-center justify-center text-center hover:bg-green-700 transition"
      >
        Form Fillup 2026-MAY Exam (EVEN SEM)
      </Link>
 </div>)}
 {true && (<div className="flex justify-center">
 <Link
        to="/admit2025december"
        className="w-[120px] h-[120px] text-xs m-2 bg-pink-600 text-white rounded-xl shadow-md flex items-center justify-center text-center hover:bg-pink-700 transition"
      >
        Admit Card 2025-DECEMBER Exam
      </Link>
      <Link
        to="/admit2026may"
        className="w-[120px] h-[120px] text-xs m-2 bg-pink-600 text-white rounded-xl shadow-md flex items-center justify-center text-center hover:bg-pink-700 transition"
      >
        Admit Card 2026-MAY Exam
      </Link>
          </div>)}
            <div className="flex justify-center">
 <Link
        to="/applyconvocation"
        className="w-[130px] h-[120px] text-xs m-2 bg-blue-500 text-white rounded-xl shadow-md flex items-center justify-center text-center hover:bg-blue-600 transition"
      >
        Apply Convocation
      </Link>
            </div>
      </div>
      </article>
    </main>
    )
  }
  
  export default HomeStudent